/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreatePartRequestDto,
  ListPartsResponseDto,
  PartResponseDto,
  UpdatePartRequestDto,
} from '../models/index';
import {
    CreatePartRequestDtoFromJSON,
    CreatePartRequestDtoToJSON,
    ListPartsResponseDtoFromJSON,
    ListPartsResponseDtoToJSON,
    PartResponseDtoFromJSON,
    PartResponseDtoToJSON,
    UpdatePartRequestDtoFromJSON,
    UpdatePartRequestDtoToJSON,
} from '../models/index';

export interface PartControllerCreateRequest {
    createPartRequestDto: CreatePartRequestDto;
}

export interface PartControllerFindAllRequest {
    limit: number;
    page: number;
    q?: string;
}

export interface PartControllerFindByIdRequest {
    id: string;
}

export interface PartControllerUpdateRequest {
    id: string;
    updatePartRequestDto: UpdatePartRequestDto;
}

/**
 * 
 */
export class PreventiveMaintenancePartsApi extends runtime.BaseAPI {

    /**
     */
    async partControllerCreateRaw(requestParameters: PartControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartResponseDto>> {
        if (requestParameters['createPartRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createPartRequestDto',
                'Required parameter "createPartRequestDto" was null or undefined when calling partControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/parts`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePartRequestDtoToJSON(requestParameters['createPartRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async partControllerCreate(requestParameters: PartControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartResponseDto> {
        const response = await this.partControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partControllerFindAllRaw(requestParameters: PartControllerFindAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPartsResponseDto>> {
        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling partControllerFindAll().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling partControllerFindAll().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/parts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListPartsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async partControllerFindAll(requestParameters: PartControllerFindAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPartsResponseDto> {
        const response = await this.partControllerFindAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partControllerFindByIdRaw(requestParameters: PartControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling partControllerFindById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/parts/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async partControllerFindById(requestParameters: PartControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartResponseDto> {
        const response = await this.partControllerFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async partControllerUpdateRaw(requestParameters: PartControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling partControllerUpdate().'
            );
        }

        if (requestParameters['updatePartRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updatePartRequestDto',
                'Required parameter "updatePartRequestDto" was null or undefined when calling partControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/parts/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePartRequestDtoToJSON(requestParameters['updatePartRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async partControllerUpdate(requestParameters: PartControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartResponseDto> {
        const response = await this.partControllerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
